import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppConfig, LocalStorageKeys, SameOriginAppPaths } from '@mkp/shared/util-app-config';
import { NEVER, Observable, of } from 'rxjs';

export function redirectUrlGuard(): Observable<true | UrlTree> {
  const router = inject(Router);
  const isLoginLanding = isLoginLandingPage(window.location.href);
  const redirectUri = getRedirectUriInLocalStorage();

  if (redirectUri && isLoginLanding) {
    const redirectUrl = constructUrlFromUri(redirectUri);

    //fallback if the route fails to construct
    if (!redirectUrl) {
      localStorage.removeItem(LocalStorageKeys.redirectUri);
      return of(router.createUrlTree([AppConfig.routes.error404]));
    }

    const path = redirectUrl.pathname;
    const queryParams = Object.fromEntries(redirectUrl.searchParams.entries());

    localStorage.removeItem(LocalStorageKeys.redirectUri);

    if (isSameOriginAppPath(path)) {
      window.location.assign(`${path}${redirectUrl.search}`);
      return NEVER;
    }

    return of(router.createUrlTree([path], { queryParams }));
  }
  return of(true);
}

const isSameOriginAppPath = (path: string): boolean =>
  SameOriginAppPaths.some((appPath) => path.startsWith(appPath));

export const constructUrlFromUri = (uri: string): URL | null => {
  try {
    return new URL(uri, window.location.origin);
  } catch (err) {
    return null;
  }
};

const isLoginLandingPage = (url: string): boolean =>
  (url.includes('code=') || url.includes('error=')) && url.includes('state=');

const getRedirectUriInLocalStorage = (): string | null =>
  localStorage.getItem(LocalStorageKeys.redirectUri);
